import { PERMISSIONS, ROUTES } from "../../config";

type PermissionChecker = (permission: PERMISSIONS) => boolean;

/**
 * TeamHub sub-sections ordered by landing priority. The first entry the user has
 * access to becomes the default destination for the TeamHub tab.
 */
export const TEAMHUB_LANDING_PRIORITY: { permission: PERMISSIONS; route: string }[] = [
    { permission: PERMISSIONS.TEAMHUB_SCHEDULE_ACCESS, route: ROUTES.TEAMHUB_SCHEDULE },
    { permission: PERMISSIONS.TEAMHUB_TEMPLATES_ACCESS, route: ROUTES.TEAMHUB_TEMPLATES },
    { permission: PERMISSIONS.TEAMHUB_TOOLS_ACCESS, route: ROUTES.TEAMHUB_TOOLS },
];

/**
 * Resolves the first TeamHub sub-section the user can actually reach.
 *
 * Returns null when the user holds the TeamHub tab permission but no sub-section
 * permission, so callers can hide the entry point instead of routing into a 404.
 */
export const resolveTeamHubLanding = (checkPermission: PermissionChecker): string | null => {
    const match = TEAMHUB_LANDING_PRIORITY.find(({ permission }) => checkPermission(permission));
    return match ? match.route : null;
};
